export interface GuestLocation {
  label: string;
  latitude?: string;
  longitude?: string;
  zipcode: string;
  stateCode?: string;
  locationType?: string;
  countyId?: string;
}

export const dualCompletePlanStates = ['AZ', 'MA', 'NY', 'PA'];

export const getShowDualCompletePlanMessaging = (
  coverageType: string,
  lob: string,
  selectedLocation: GuestLocation | undefined
): boolean => {
  const isMnrDental = coverageType === 'D' && lob === 'MR';
  return (
    selectedLocation &&
    dualCompletePlanStates.includes(selectedLocation?.stateCode) &&
    isMnrDental
  );
};

const singlePlanCriteria: { lob: string; coverageType: string }[] = [
  { lob: 'EI', coverageType: 'B' },
  { lob: 'EI', coverageType: 'V' },
  { lob: 'MR', coverageType: 'V' },
  { lob: 'IFP', coverageType: 'V' },
];

export const isSinglePlan = (
  lob: string,
  coverageType: string | null
): boolean =>
  singlePlanCriteria.some(
    (criteria) => criteria.lob === lob && criteria.coverageType === coverageType
  );
